var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmoBasket = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.806 1.542A1.736 1.736 0 0 0 3.5 2.5V3h3v-.5c0-.253-.08-.644-.306-.958C5.987 1.254 5.637 1 5 1c-.637 0-.987.254-1.194.542M7.5 3v-.5c0-.413-.12-1.022-.494-1.542C6.613.412 5.963 0 5 0c-.963 0-1.613.412-2.006.958A2.733 2.733 0 0 0 2.5 2.5V3H0v1h.54l.462 5.542A.5.5 0 0 0 1.5 10h7a.5.5 0 0 0 .498-.458L9.46 4H10V3z",
    clipRule: "evenodd"
  })));
};
export default SvgEmoBasket;